import { ListRolesRequest, RoleInfo } from '@models/role.model'
import { MyOrganizationInfo, OrganizationInfo } from '../../models/organization.model'
import {
	LandingPageProjectInfo,
	ListProjectsRequest,
	ProjectInfo,
} from '../../models/projects.model'
import { AuditTrail, ListUserRequest, UserInfo, UserList } from '../../models/user.model'
import {SMSAPI} from '../index'
import { DateFilter, GeneralListRequest, Filters } from '@models/common.model'
import { ContactInfo, RecipientDetailInfo } from '@models/recipient.model'
import { convertFiltersToFilterGroup } from '@utils/filterConverter'

const GetRecipientSummary = async (req: GeneralListRequest & { [key: string]: any }) => {
	
	let url = `/contact/contacts/all/recipient_details`;
	
	// Extract pagination, search, sort, and filters from request
	const { pagination, search, sort, ...filterRest } = req
	
	// Convert Filters object to FilterGroup format
	const filterGroup = convertFiltersToFilterGroup(filterRest as Filters)
	
	const params: any = {
		...(pagination && pagination.page_size && pagination.page && {
			skip: (pagination.page - 1) * pagination.page_size,
			limit: pagination.page_size,
		}),
		...(filterGroup && {
			// Serialize FilterGroup as JSON string for query params
			filters: JSON.stringify(filterGroup),
		}),
		...(search && search.length > 0 && {
			// Serialize search array as JSON string or comma-separated
			search: Array.isArray(search) ? search.join(',') : search,
		}),
		...(sort && sort.by && sort.order_by && {
			sort_by: sort.by,
			sort_order: sort.order_by,
		}),
	}
	
	
	return await SMSAPI.get<{items: RecipientDetailInfo[],total_count: number}>(url,{params}).then((rep) => {
		return rep.data
	})
}


const GetRecipientById = async (id: string) => {
	let url = `/contact/contacts/${id}/recipient_detail`;
	return await SMSAPI.get<RecipientDetailInfo>(url).then((rep) => {
		return rep.data
	})
}

const GetAllGroups = async () => {
	let url = `/contact/groups/all`;
	const params = {
		skip: 0,
		limit: 100
	}
	return await SMSAPI.get<Array<{id: string, building: string}>>(url, {params}).then((rep) => {
		return rep.data
	})
}

const CreateContact = async (data: { building: string; name: string; position: string; contact_infos: Array<{ channel_type: string; info: string }> }) => {
	let url = `/contact/contacts`;
	return await SMSAPI.post(url, data).then((rep) => {
		return rep.data
	})
}

const UpdateContact = async (contactId: string, data: { name?: string; position?: string }) => {
	let url = `/contact/contacts/${contactId}`;
	return await SMSAPI.put(url, data).then((rep) => {
		return rep.data
	})
}

const UpdateContactInfo = async (contactInfoId: string, data: { info?: string; channel_type?: string }) => {
	let url = `/contact/contacts/contact_infos/${contactInfoId}`;
	return await SMSAPI.put(url, data).then((rep) => {
		return rep.data
	})
}

const AddContactToGroup = async (groupId: string, contactIds: string[]) => {
	let url = `/contact/groups/${groupId}/mapping`;
	return await SMSAPI.post(url, contactIds ).then((rep) => {
		return rep.data
	})
}

const RemoveContactFromGroup = async (groupId: string, contactId: string) => {
	let url = `/contact/groups/${groupId}/mapping`;
	return await SMSAPI.put(url, {}, { params: { contact_id: contactId } }).then((rep) => {
		return rep.data
	})
}

const DeleteContactInfo = async (contactInfoId: string) => {
	let url = `/contact/contacts/contact_infos/${contactInfoId}`;
	return await SMSAPI.delete(url).then((rep) => {
		return rep.data
	})
}

const DeleteContact = async (contactId: string) => {
	let url = `/contact/contacts/${contactId}`;
	return await SMSAPI.delete(url).then((rep) => {
		return rep.data
	})
}

const RecipientService = {
	GetRecipientSummary,
	GetRecipientById,
	GetAllGroups,
	CreateContact,
	UpdateContact,
	UpdateContactInfo,
	AddContactToGroup,
	RemoveContactFromGroup,
	DeleteContactInfo,
	DeleteContact
}

export default RecipientService
